import { S3_BUCKET_URL } from '@/constants';
import { webCampaign } from '@/modules/webCampaign.ts';
import { useDominateLayoutSelections } from '@/pages/Onboarding/hooks/useDominateLayoutSelections';
import { MainImageHeader } from '@/pages/Paywall/components/MainImageHeader';
import { PaywallProFeatures } from '@/pages/Paywall/components/ProFeatures';

import { generatePlansAccess } from '../../utils/generatePlansAccess';

import {
  BulbeBackground,
  BulbeContainer,
  BulbeText,
  MainImageContentStyles,
  MainImageStyles,
} from './MainImage.styles';

export const SectionMainImage: React.FC = () => {
  const {
    dominatrix_visual_style,
    tools,
    safeword_choice,
    voice_style,
    control_style,
    name,
  } = useDominateLayoutSelections();

  const getBackgroundSrc = () => {
    const notes = webCampaign.setup.paywallNotes;

    if (notes?.includes('jia')) {
      return `${S3_BUCKET_URL}/paywall/v5-dominate/jia/paywall.png`;
    }

    if (notes?.includes('lucy')) {
      return `${S3_BUCKET_URL}/paywall/v5-dominate/lucy-v2/paywall.png`;
    }

    return `${S3_BUCKET_URL}/paywall/v5-dominate/${dominatrix_visual_style}_${tools}.png`;
  };

  const getBubbleText = () => {
    const notes = webCampaign.getLayoutNotes();

    if (notes?.includes('jia') || notes?.includes('lucy')) {
      return "I'm interested. That's rare.\nGet access. Prove you're serious.";
    }

    return `Don't make me repeat myself, ${name}. Finish it.`;
  };

  const features = generatePlansAccess({
    control_style: control_style,
    dominatrix_visual_style: dominatrix_visual_style,
    voice_style: voice_style,
    safeword_choice: safeword_choice,
    tools: tools,
  });

  return (
    <MainImageStyles backgroundSrc={getBackgroundSrc()}>
      <MainImageHeader />
      <BulbeContainer>
        <BulbeBackground
          src={`${S3_BUCKET_URL}/paywall/v5-dominate/bubble.png`}
          alt=""
        />
        <BulbeText>{getBubbleText()}</BulbeText>
      </BulbeContainer>
      <MainImageContentStyles>
        <PaywallProFeatures features={features} />
      </MainImageContentStyles>
    </MainImageStyles>
  );
};
